import { BaseTooltip, type BaseTooltipTriggerProps } from "./base-tooltip";

export const PromptBrandSpecificTooltip = ({ trigger, triggerClassName }: BaseTooltipTriggerProps = {}) => {
      return (
            <BaseTooltip trigger={trigger} triggerClassName={triggerClassName}>
                  <p>Focuses on the brand itself and the way it is perceived.</p>
            </BaseTooltip>
      );
};
